import { h } from 'preact'
import { connect } from 'redux-zero/preact'

const mapToProps = ({
    message,
    message_title,
    message_type
}) => ({
    message,
    message_title,
    message_type
})

const MaintenanceMode = (props) => {

    const isRevoked =
        props.message_type ===
        'session_revoked'

    return (
        <div className="et-session-overlay">

            <div className="et-session-modal">
                { !isRevoked && (
                    <div className="et-session-logo-wrap">
                        <img
                            src="/img/neo.svg"
                            alt="Neo Logo"
                            className="et-session-logo"
                        />
                    </div>
                )}



                <h1 className="et-session-title">
                    {
                        isRevoked
                            ? (
                                props.message_title ||
                                'Session Revoked'
                            )
                            : "We'll Be Right Back"
                    }
                </h1>

                {
                    isRevoked ? (
                        <p className="et-session-message">
                            {
                                props.message ||
                                'Your session has ended because another login was detected.'
                            }
                        </p>
                    ) : (
                        <div>
                            <p className="et-session-message">
                                We're performing scheduled maintenance.
                            </p>

                            <p className="et-session-submessage">
                                We'll be back online shortly.
                            </p>
                        </div>
                    )
                }

            </div>

        </div>
    )
}

export default connect(mapToProps)(MaintenanceMode)